module.exports = __webpack_public_path__ + "media/images/page/kodawari1_sample-03efac077ec450edd75b0a260a211639.jpg";